(function () {
  const onBlurListMenu = (header) => {
    const listMenuItems = header.querySelectorAll(
      ".list-menu--inline > .list-menu-item"
    );

    const onBlurInnerElements = () => {
      listMenuItems.forEach((item) => {
        item.querySelectorAll("a, details, summary").forEach((el) => {
          el.blur();
        });
        item.blur();
      });
    };

    listMenuItems.forEach((listMenuItem) => {
      listMenuItem.addEventListener("mouseleave", onBlurInnerElements);
    });
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const isBoxedMode = Boolean(header.querySelector(".header--boxed-mode"));
    const isOverlayMode = Boolean(
      header.querySelector(".header--overlay-mode")
    );
    const breadcrumbs = document.querySelector(
      ".base-breadcrumbs #breadcrumbs"
    );

    const removeColorScheme = (element) => {
      if (!element) return;
      let classNames = element.getAttribute("class");
      classNames = classNames.replace(/color-background-\d+/g, "");
      element.setAttribute("class", classNames);
    };

    if (sections.length > 0 && (isBoxedMode || isOverlayMode)) {
      const hasTargetSection = sections[0].classList.contains(
        "has-header-interaction"
      );
      const sectionTargetChild = sections[0].querySelector(
        "[data-header-interaction]"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      if (hasTargetSection && sectionTargetChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.remove("not-margin");
          header.classList.remove("not-mode");
          if (isOverlayMode) header.classList.add("overlay-mode-enabled");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme = sectionTargetChild.dataset.colorScheme;
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          sections[0].classList.add("not-margin");
          header.classList.add("not-mode");
          header.classList.remove("overlay-mode-enabled");
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        header.classList.add("not-mode");
        header.classList.remove("overlay-mode-enabled");
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    } else {
      header.classList.add("not-mode");
      header.classList.remove("overlay-mode-enabled");
      if (breadcrumbs) removeColorScheme(breadcrumbs);
    }

    if (header.classList.contains("overlay-mode-enabled")) {
      const headerWrapper = header.querySelector(".header-wrapper");
      if (!headerWrapper) return;

      const triggeredItems = headerWrapper.querySelectorAll(
        '.list-menu--inline > .list-menu-item[data-show-on-hover="true"]'
      );

      let removeHoverTimeout = null;
      let removeAnimateTimeout = null;

      triggeredItems.forEach((triggeredItem) => {
        triggeredItem.addEventListener("mouseenter", () => {
          if (header.classList.contains("shopify-section-header-sticky")) {
            return;
          }
          clearTimeout(removeHoverTimeout);
          clearTimeout(removeAnimateTimeout);

          headerWrapper.classList.add("hover-triggered");
          headerWrapper.classList.add("animate-triggered");
        });

        triggeredItem.addEventListener("mouseleave", () => {
          removeHoverTimeout = setTimeout(() => {
            const isStillHovered = Array.from(triggeredItems).some((el) =>
              el.matches(":hover")
            );

            if (!isStillHovered) {
              headerWrapper.classList.remove("hover-triggered");

              removeAnimateTimeout = setTimeout(() => {
                headerWrapper.classList.remove("animate-triggered");
              }, 300);
            }
          }, 0);
        });
      });
    }
  };

  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  const initMegaObserver = (header) => {
    const megaMenuLinks = header.querySelectorAll(
      ".list-menu--megamenu, .list-menu--megasubmenu"
    );
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    const headerEl = header.querySelector(".header.header--has-menu");
    if (!headerEl) return;

    const calcMegaMenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      megaMenuLinks.forEach((link) => {
        const megaMenuEl =
          link.querySelector(".header__mega-menu") ||
          link.querySelector(".header__mega-submenu");

        if (!megaMenuEl) return;

        const linkMenuRect = link.getBoundingClientRect();

        const extraHeight = Math.abs(linkMenuRect.bottom - headerRect.bottom);
        const extraHeightFix = Math.ceil(extraHeight * 100) / 100;
        const extraLeft = (linkMenuRect.left - 20).toFixed(2);
        const extraWidth = (linkMenuRect.width + 30).toFixed(2);
        megaMenuEl.style.setProperty("--extra-height", `${extraHeightFix}px`);
        megaMenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        megaMenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaMenuPosition();
      });
    });

    observer.observe(header);
  };

  // Mirror CSS-driven open state into data-mega-open so ARIA stays in sync
  // even though the panel is opened by :hover / :focus-within in CSS.
  const syncAriaState = (triggerItem) => {
    const open = triggerItem.dataset.megaOpen === "true";
    const triggerLink = triggerItem.querySelector("[data-mega-menu-trigger]");
    const panel = triggerItem.querySelector("[data-mega-menu-panel]");
    if (triggerLink) {
      triggerLink.setAttribute("aria-expanded", open ? "true" : "false");
    }
    if (panel) {
      panel.setAttribute("aria-hidden", open ? "false" : "true");
    }
  };

  const setMegaOpen = (triggerItem, open) => {
    triggerItem.dataset.megaOpen = open ? "true" : "false";
    syncAriaState(triggerItem);
  };

  const openMegaMenu = (triggerItem) => {
    triggerItem.removeAttribute("data-mega-collapsed");
    setMegaOpen(triggerItem, true);
  };

  // Escape collapses the panel even while focus-within still applies via the
  // data-mega-collapsed CSS latch, then returns focus to the trigger link.
  const escMegaMenu = (triggerItem) => {
    triggerItem.setAttribute("data-mega-collapsed", "");
    setMegaOpen(triggerItem, false);
    const triggerLink = triggerItem.querySelector("[data-mega-menu-trigger]");
    triggerLink?.focus();
  };

  // Arrow-key navigation for the desktop mega menu (disclosure-navigation
  // pattern: native <a> semantics are preserved, only focus management is added).
  const initMegaMenuKeyboard = (header) => {
    const megaMenuPanels = header.querySelectorAll("[data-mega-menu-panel]");
    if (!megaMenuPanels.length) return;

    megaMenuPanels.forEach((panel) => {
      // initHeader re-runs on Shopify section events; bind only once per panel.
      if (panel.dataset.megaKeyboardBound === "true") return;
      panel.dataset.megaKeyboardBound = "true";

      const triggerItem = panel.closest("[data-mega-menu-root]");
      if (!triggerItem) return;

      const allItems = panel.querySelectorAll("[data-mega-menu-item]");
      if (!allItems.length) return;

      // Roving tabindex: only one item is in the sequential tab order at a time.
      allItems.forEach((item, index) => {
        item.setAttribute("tabindex", index === 0 ? "0" : "-1");
      });

      const getVisibleItems = () =>
        Array.from(allItems).filter((item) => item.offsetParent !== null);

      const focusItemAt = (items, index) => {
        const boundedIndex = (index + items.length) % items.length;
        items.forEach((item) => item.setAttribute("tabindex", "-1"));
        const target = items[boundedIndex];
        target.setAttribute("tabindex", "0");
        target.focus();
      };

      const focusColumnSibling = (direction) => {
        const columns = Array.from(
          panel.querySelectorAll("[data-mega-menu-column]")
        );
        if (!columns.length) return;
        const currentColumn = document.activeElement.closest(
          "[data-mega-menu-column]"
        );
        let nextColumn;
        if (!currentColumn) {
          // Focus is inside the panel but not within a column (edge case);
          // fall through to the first or last column so focus stays inside
          // the menu instead of escaping.
          nextColumn = direction >= 0 ? columns[0] : columns[columns.length - 1];
        } else {
          const columnIndex = columns.indexOf(currentColumn);
          nextColumn =
            columns[
              (columnIndex + direction + columns.length) % columns.length
            ];
        }
        const firstInColumn = nextColumn?.querySelector("[data-mega-menu-item]");
        if (!firstInColumn) return;
        Array.from(allItems).forEach((item) =>
          item.setAttribute("tabindex", "-1")
        );
        firstInColumn.setAttribute("tabindex", "0");
        firstInColumn.focus();
      };

      const handleKeydown = (event) => {
        const items = getVisibleItems();
        if (!items.length) return;
        const currentIndex = items.indexOf(document.activeElement);

        switch (event.key) {
          case "ArrowDown":
            event.preventDefault();
            focusItemAt(items, currentIndex < 0 ? 0 : currentIndex + 1);
            break;
          case "ArrowUp":
            event.preventDefault();
            focusItemAt(items, currentIndex < 0 ? 0 : currentIndex - 1);
            break;
          case "ArrowRight":
            event.preventDefault();
            focusColumnSibling(1);
            break;
          case "ArrowLeft":
            event.preventDefault();
            focusColumnSibling(-1);
            break;
          case "Home":
            event.preventDefault();
            focusItemAt(items, 0);
            break;
          case "End":
            event.preventDefault();
            focusItemAt(items, items.length - 1);
            break;
          case "Escape":
            event.preventDefault();
            escMegaMenu(triggerItem);
            break;
          default:
            break;
        }
      };

      panel.addEventListener("keydown", handleKeydown);

      // The panel opens via :hover (mouse) or data-mega-open="true" (JS).
      // Tab / arrow focus alone must NOT open it (AC #3), so there's no
      // focusin auto-open. mouseenter mirrors the hover-open into the JS
      // state so ARIA stays accurate; mouseleave / focusout (when leaving
      // the LI entirely) clear state and the Esc latch.
      triggerItem.addEventListener("mouseenter", () => {
        triggerItem.removeAttribute("data-mega-collapsed");
        setMegaOpen(triggerItem, true);
      });
      triggerItem.addEventListener("mouseleave", () => {
        if (triggerItem.matches(":focus-within")) return;
        setMegaOpen(triggerItem, false);
      });
      triggerItem.addEventListener("focusout", (event) => {
        if (triggerItem.contains(event.relatedTarget)) return;
        triggerItem.removeAttribute("data-mega-collapsed");
        setMegaOpen(triggerItem, false);
      });
    });
  };

  // Keyboard handler for the top-level horizontal nav. Arrow keys move
  // focus across top-level items; ArrowDown on a mega trigger opens the
  // panel and lands focus on the first item; ArrowUp / Esc close it.
  const initTopLevelKeyboard = (header) => {
    const lists = header.querySelectorAll(".list-menu--inline");
    if (!lists.length) return;

    lists.forEach((list) => {
      if (list.dataset.topMenuKeyboardBound === "true") return;
      list.dataset.topMenuKeyboardBound = "true";

      list.addEventListener("keydown", (event) => {
        const trigger = event.target.closest("[data-top-menu-item]");
        if (!trigger || !list.contains(trigger)) return;

        const items = Array.from(
          list.querySelectorAll("[data-top-menu-item]")
        );
        const currentIndex = items.indexOf(trigger);
        const triggerItem = trigger.closest("[data-mega-menu-root]");
        const isMegaTrigger = !!triggerItem;

        const focusAt = (index) => {
          const next = items[(index + items.length) % items.length];
          next?.focus();
        };

        switch (event.key) {
          case "ArrowRight":
            event.preventDefault();
            focusAt(currentIndex + 1);
            break;
          case "ArrowLeft":
            event.preventDefault();
            focusAt(currentIndex - 1);
            break;
          case "Home":
            event.preventDefault();
            focusAt(0);
            break;
          case "End":
            event.preventDefault();
            focusAt(items.length - 1);
            break;
          case "ArrowDown": {
            if (!isMegaTrigger) break;
            event.preventDefault();
            openMegaMenu(triggerItem);
            const firstItem = triggerItem.querySelector(
              "[data-mega-menu-panel] [data-mega-menu-item]"
            );
            firstItem?.focus();
            break;
          }
          case "ArrowUp":
            if (!isMegaTrigger) break;
            if (triggerItem.dataset.megaOpen !== "true") break;
            event.preventDefault();
            escMegaMenu(triggerItem);
            break;
          case "Escape":
            if (!isMegaTrigger) break;
            event.preventDefault();
            escMegaMenu(triggerItem);
            break;
          default:
            break;
        }
      });
    });
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    onBlurListMenu(header);
    initHeaderOverlay(header);
    initMegaObserver(header);
    initMegaSubmenu(header);
    initMegaMenuKeyboard(header);
    initTopLevelKeyboard(header);
  };

  initHeader();

  // Global Escape: close any open mega menu regardless of where focus is,
  // so users who hover-opened the panel can dismiss it without first
  // landing focus inside the header.
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const openTrigger = document.querySelector(
      '[data-mega-menu-root][data-mega-open="true"]'
    );
    if (!openTrigger) return;
    event.preventDefault();
    escMegaMenu(openTrigger);
  });

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

if (!customElements.get("burger-menu")) {
  customElements.define(
    "burger-menu",
    class BurgerMenu extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.burgerMenu = this.querySelector(".burger-menu");
        this.openButton = this.querySelector(".burger-menu__toggle");
        this.closeButton = this.querySelector(".modal-close-button");
        this.overlayEl = this.querySelector(".modal__overlay");

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
      }

      connectedCallback() {
        this.openButton?.addEventListener("click", this.open);
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener("click", this.open);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);
      }

      onOpen() {
        if (this.header) this.header.preventHide = true;
        this.setAttribute("open", true);
        this.burgerMenu.classList.add("modal--open");
        document.body.classList.add("overflow-hidden-desktop-menu");
        if (this.burgerMenu && this.closeButton) {
          trapFocus(this.burgerMenu, this.closeButton);
        }
      }

      onClose() {
        document.body.classList.remove("overflow-hidden-desktop-menu");
        document.body.classList.remove("overflow-hidden");
        this.removeAttribute("open");
        this.burgerMenu.classList.remove("modal--open");
        removeTrapFocus(this.openButton);
        this.querySelectorAll("menu-drawer").forEach((submenu) => {
          if (submenu && typeof submenu.closeMenuDrawer === "function") {
            submenu.closeMenuDrawer(this.openButton);
          }
        });
        if (this.header) this.header.preventHide = false;
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }
    }
  );
}

if (!customElements.get("header-search")) {
  customElements.define(
    "header-search",
    class HeaderSearch extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.searchLink = this.querySelector(".header__button--search");
        this.modalContainer = this.querySelector(".header__search-modal");
        this.closeButton =
          this.querySelector(".modal-close-button") ||
          this.querySelector(".mobile-submenu__back");
        this.overlayEl = this.querySelector(".modal__overlay");
        this.location = this.dataset.location;

        this.searchInput = this.querySelector(
          "#Search-In-Modal, #Search-In-Modal-Mobile"
        );

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
      }

      connectedCallback() {
        this.searchLink?.addEventListener("click", this.open);
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);

        this.setTimeout = null;
      }

      disconnectedCallback() {
        this.searchLink?.removeEventListener("click", this.open);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);
      }

      onOpen(event) {
        event.preventDefault();
        this.setTimeout && window.clearTimeout(this.setTimeout);
        if (this.header) this.header.preventHide = true;
        this.setAttribute("open", true);
        this.modalContainer.classList.add("modal--open");

        // transition duration in modal 300ms
        if (this.searchInput && navigator.userAgent.indexOf("iPhone") === -1) {
          this.setTimeout = setTimeout(() => {
            trapFocus(this.modalContainer, this.searchInput);
          }, 300);
        }

        if (this.location === "desktop-header") {
          document.body.classList.add("overflow-hidden-laptop");
        }
      }

      onClose() {
        this.setTimeout && window.clearTimeout(this.setTimeout);
        this.removeAttribute("open");
        this.modalContainer.classList.remove("modal--open");

        if (this.location === "desktop-header") {
          document.body.classList.remove("overflow-hidden-laptop");
        }

        removeTrapFocus(this.searchLink);

        if (this.header) this.header.preventHide = false;
        const parentMenu = this.closest("header-drawer");
        if (!parentMenu) removeTrapFocus(this.searchLink);
        if (parentMenu) {
          removeTrapFocus(parentMenu.closeBtn);
          const parentOpenScrollY = parentMenu.openScrollY || 0;
          window.scrollTo(0, parentOpenScrollY);
        }
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }
    }
  );
}
